export default "__VITE_ASSET__du_2Ch9h__"